export default "__VITE_ASSET__Djegg4fX__"